module.exports = __webpack_public_path__ + "static/img/DS_logo.769941f0.png";